import React from "react";
import { modal } from "../modal";
import { MapControl } from "../../pages/area/MapControl";

export const modal_map = props => {
  const { asset, target, history, type } = props;
  const assets = props.assets || [asset];
  return (
    <div className="modal_map modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="area_map"><div className="container"><div className="content"><div className="control">
        <MapControl list={assets} history={history} target={target} type={type} isDetail={false}/>
      </div></div></div></div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_map.jsx